import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import type {
    AttendEventMutation,
    AttendEventMutationVariables,
} from './useEventActions.mutations.generated'

export const ATTEND_EVENT: TypedDocumentNode<
    AttendEventMutation,
    AttendEventMutationVariables
> = gql`
    mutation AttendEvent($input: attendEventInput!) {
        attendEvent(input: $input) {
            entity {
                guid
                ... on Event {
                    isAttending
                }
            }
        }
    }
`
